import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Router, hashHistory, browserHistory, Route, IndexRoute, Redirect } from 'react-router';

import moment from 'moment';
const platform = require('platform');
import $ from 'jquery';

import routeConfig from './config/route.json';

const pageTransitionName = 'page';
const transitionClassName = 'transition-group';
const transitionDuration = 1000;
const transitionEnterTimeout = 2 * transitionDuration;

import './App.css';

import DeviceController from './util/DeviceController';

/* Desktop start */
import Header from './desktop/layout/Header';
import Footer from './desktop/layout/Footer';

import Landing from './desktop/page/Landing';

import Home from './desktop/page/Home';
import Gallery from './desktop/page/Gallery';
import Announcement from './desktop/page/Announcement';
import SalesBrochure from './desktop/page/SalesBrochure';
import PriceList from './desktop/page/PriceList';
import SalesArrangements from './desktop/page/SalesArrangements';
import RegisterOfTransactions from './desktop/page/RegisterOfTransactions';
import DeedOfMutualCovenant from './desktop/page/DeedOfMutualCovenant';
import AerialPhotograph from './desktop/page/AerialPhotograph';
import TenderDocuments from './desktop/page/TenderDocuments';
/* Desktop end */


/* Mobile start */
import MMenu from './mobile/layout/Menu';
import MFooter from './mobile/layout/Footer';

import MLanding from './mobile/page/Landing';

import MHome from './mobile/page/Home';
import MGallery from './mobile/page/Gallery';
import MAnnouncement from './mobile/page/Announcement';
import MSalesBrochure from './mobile/page/SalesBrochure';
import MPriceList from './mobile/page/PriceList';
import MSalesArrangements from './mobile/page/SalesArrangements';
import MRegisterOfTransactions from './mobile/page/RegisterOfTransactions';
import MDeedOfMutualCovenant from './mobile/page/DeedOfMutualCovenant';
import MAerialPhotograph from './mobile/page/AerialPhotograph';
import MTenderDocuments from './mobile/page/TenderDocuments';

import MApplication from './mobile/page/Application';
/* Mobile end */

import seo from './config/seo';

class Page extends Component {

  constructor(props) {
    super(props);
    
    this.updateLang = this.updateLang.bind(this);

    this.lang = this.props.location.pathname.split('/')[1];
    if (!this.lang || (this.lang !== 'en' && this.lang !== 'tc' && this.lang !== 'sc')) {
      this.lang = 'en'
    }

    this.state = {
      ...this.props,
      lang: this.lang
    }

    this.loadData = this.loadData.bind(this);
    this.bgImageOnload = this.bgImageOnload.bind(this);
    this.bgImageInit = this.bgImageInit.bind(this);
    this.updateRouteByDevice = this.updateRouteByDevice.bind(this);
  }

  componentDidMount() {
    this.changePositioning();
    this.loadData();

    setInterval(() => {
      this.updateTitle();
    }, 2000)
  }

  updateTitle = () => {
    const relevantSeo = seo.filter(s => {
      const seoPath = '/p2' + s.dest.slice(7, 100);
      const currentPath = (
        window.location.pathname.slice(-1) === '/' ?
          window.location.pathname.slice(0, -1) :
          window.location.pathname
      )
      return seoPath === currentPath
    })
    // console.log(seo)
    // console.log(relevantSeo[0])
    // console.log(window.location.pathname)
    window.document.title = relevantSeo && relevantSeo[0] ?
      relevantSeo[0].metaTitle :
      window.document.title;
  }

  transformData(key, data) {

    function renderTitle (updated_at, lang) {
      let u = '';
      if (!isNaN(updated_at)) {
        u = moment(updated_at * 1000).format('DD-MM-YYYY') + ' '
      }
      return u + lang;
    }


    let localData = []
    if (key !== 'gallery') {
      // 1. extract
      if (key === 'sales_arrangements' || key === 'price_list' ) {
        for (let key in data) {
          localData.push({
            'sc': data[key].simp,
            'tc':  data[key].trad,
            'en': data[key].eng,
            'url': '/shk_cms2/public/index.php?preview=' + data[key].path,
            'order': data[key].order ? data[key].order : ''
          })
        }
      } else {
        for (let key in data) {
          localData.push({
            'sc': data[key].simp,
            'tc': data[key].trad,
            'en': data[key].eng,
            'url': '/shk_cms2/public/index.php?preview=' + data[key].path,
            'order': data[key].order ? data[key].order : ''
          })
        }
      }

      // 2. sort
      localData = localData.sort(function(a, b){
        let keyA = parseInt(a.order);
        let keyB = parseInt(b.order);

        keyA = isNaN(keyA) ? 0 : keyA;
        keyB = isNaN(keyB) ? 0 : keyB;

        // Compare the 2 dates
        if(keyA < keyB) return -1;
        if(keyA > keyB) return 1;
        return 0;
      });
    } else {
      // 1. extract
      for (let key in data) {
        if (data[key].file_type === 'img'){
          localData.push({
            img: '/shk_cms2/public/index.php?preview=' + data[key].path,
            updated_at: data[key].updated_at
          })
        } else {
          localData.push({
            sc: data[key].simp,
            tc: data[key].trad,
            en: data[key].eng,
            url: '/shk_cms2/public/index.php?preview=' + data[key].path,
            updated_at: data[key].updated_at
          })
        }
      }

      // 2. sort
      localData = localData.sort(function(a, b){
        let keyA = parseInt(a.updated_at);
        let keyB = parseInt(b.updated_at);

        keyA = isNaN(keyA) ? 0 : keyA;
        keyB = isNaN(keyB) ? 0 : keyB;

        // Compare the 2 dates
        return keyB - keyA;
      });

      console.log(localData)
    }

    return localData
  }

  loadData() {
    let t = this;
    let transData = {};

    // /shk_cms2/public/index.php?get_notice=eng
    // http://www.mocky.io/v2/5e9c16ad30000057000a7d69

    const url = '/shk_cms2/public/index.php?list'
    // const url = 'http://www.mocky.io/v2/5e9c16ad30000057000a7d69?mocky-delay=3000ms'

    const pingInterval = 5;
    const cachePeriod = 16;

    // !!!!!!!!!! prod
    let httpCall = null;
    const getList = function() {
      // 1. use cache if it is within cache period
      const previousCacheTimestamp = window.localStorage.getItem('timestamp-p2') || 0;
      const timeBetweenPreviousCache = (new Date()).getTime() - previousCacheTimestamp;

      console.log('timeBetweenPreviousCache: ' + (timeBetweenPreviousCache / 1000) + 's');
      if (timeBetweenPreviousCache / 1000 < cachePeriod) {
        console.log('< cachePeriod: ' + cachePeriod + 's');
        console.log('=> use cache value')

        transData = window.localStorage.getItem('data');
        t.setState({
          data: JSON.parse(transData)
        });
        return;
      }

      // 2. make API call if not
      httpCall = $.ajax({
        url,
        success: function(d) {
          if (Object.keys(transData).length === 0 && transData.constructor === Object && d[0] !== '<') {

            console.log('getList success');
            for (let key in d) {
              transData[key] = t.transformData(key, d[key])
            }
  
            transData.aerial_photograph = transData.aerial_photograph ? transData.aerial_photograph : []
            transData.announcement = transData.announcement ? transData.announcement : []
            transData.deed_of_mutual_covenant = transData.deed_of_mutual_covenant ? transData.deed_of_mutual_covenant : []
            transData.gallery = transData.gallery ? transData.gallery : []
            transData.price_list = transData.price_list ? transData.price_list : []
            transData.register_of_transactions = transData.register_of_transactions ? transData.register_of_transactions : []
            transData.sales_arrangements = transData.sales_arrangements ? transData.sales_arrangements : []
            transData.sales_brochure = transData.sales_brochure ? transData.sales_brochure : []
  
            window.localStorage.setItem('data', JSON.stringify(transData));
            window.localStorage.setItem('timestamp-p2', (new Date()).getTime());

            t.setState({
              data: transData
            });
            
          }
        }
      });
    }

    const execGetList = function() {
      console.log('execGetList...');
      console.log(transData)
      if (Object.keys(transData).length === 0 && transData.constructor === Object) {
        // if (httpCall) httpCall.abort();
        getList();
        setTimeout(execGetList, pingInterval * 1000);
      }
    }

    getList();
    t.t0 = setTimeout(execGetList, pingInterval * 1000);
    // !!!!!!!!!! prod
    


    
    // !!!!!!!!!! dev
    // const respTime = 1;
    // setTimeout(() => {

    //   let d = {
    //     "sales_brochure":{"1":{"eng":"Sales Brochure - Part 1","trad":"\u552e\u6a13\u8aaa\u660e\u66f8-\u7b2c\u4e00\u90e8\u5206","simp":"\u552e\u697c\u8bf4\u660e\u4e66-\u7b2c\u4e00\u90e8\u5206","path":"sales_brochure\/7ZaWU31On3HC6QrlT3wHEJlG0FqU1GJYt0tOa1Jf.pdf","order":"1","updated_at":1535702040,"file_name":"StBarths_Sales Brochure_Part1.pdf","file_size":"36.45 MB"},"2":{"eng":"Sales Brochure - Part 2","trad":"\u552e\u6a13\u8aaa\u660e\u66f8-\u7b2c\u4e8c\u90e8\u5206","simp":"\u552e\u697c\u8bf4\u660e\u4e66-\u7b2c\u4e8c\u90e8\u5206","path":"sales_brochure\/e09K8Yqi87u91ZazDm2NMRPaPHJKfx2w4JNPtXjr.pdf","order":"2","updated_at":1532679710,"file_name":"SB_SB_part2.pdf","file_size":"11.57 MB"}},
    //     "price_list":{"1":{"eng":"07-04-2018 Price List No.55","trad":"07-04-2018 \u50f9\u55ae\u7b2c55\u865f","simp":"07-04-2018 \u4ef7\u5355\u7b2c55\u53f7","path":"price_list\/qiqiqBMHOLm3myf1medK1B9qwTNtqojLAKIB2A4A.png","file_name":"001.png","file_size":"1.05 MB","updated_at":1523031283,"date_of_printing":"07-04-2018","serial_number":"55","order":1}},
    //     "sales_arrangements":{"1":{"eng":"04-03-2018 Sales Arrangements No.21","trad":"04-03-2018 \u92b7\u552e\u5b89\u6392\u7b2c21\u865f","simp":"04-03-2018 \u9500\u552e\u5b89\u6392\u7b2c21\u53f7","path":"sales_arrangements\/wEWyS9x4dEdQIBhbZWJsM68OlaZ3kcGEwGuPPhW1.jpeg","file_name":"nature-forest-waves-trees.jpg","file_size":"629.92 KB","updated_at":1520171940,"issue_date":"04-03-2018","serial_number":"21","order":1},"2":{"eng":"04-03-2018 Sales Arrangements No.2258","trad":"04-03-2018 \u92b7\u552e\u5b89\u6392\u7b2c2258\u865f","simp":"04-03-2018 \u9500\u552e\u5b89\u6392\u7b2c2258\u53f7","path":"sales_arrangements\/oK4F2boolETTq4fzILwkZZqt7SUuhNwAxDEWgv2p.jpeg","file_name":"t3.jpeg","file_size":"1.91 MB","updated_at":1520175560,"issue_date":"04-03-2018","serial_number":"2258","order":2},"3":{"eng":"04-03-2018 Sales Arrangements No.2308","trad":"04-03-2018 \u92b7\u552e\u5b89\u6392\u7b2c2308\u865f","simp":"04-03-2018 \u9500\u552e\u5b89\u6392\u7b2c2308\u53f7","path":"sales_arrangements\/uiIrS5tRbpIZIvhbR83D77yplguy4Wl6qSxp1tez.pdf","file_name":"Naamloosdocument.pdf","file_size":"17.58 KB","updated_at":1520176348,"issue_date":"04-03-2018","serial_number":"2308","order":3}},
    //     "gallery":{"1":{"eng":"t1.jpg","trad":"t1.jpg","simp":"t1.jpg","path":"gallery\/HPG5ysxbfvGFFkvNfcQqjXMpTEi16nYk36bgo1mC.jpeg","file_name":"t1.jpg","file_size":"712.96 KB","file_type":"img","updated_at":1513219252},"2":{"eng":"t2.jpg","trad":"t2.jpg","simp":"t2.jpg","path":"gallery\/T9kK4IT3BXqfF0M0xSwDwAZJUdmZXoGP75pfohEV.jpeg","file_name":"t2.jpg","file_size":"1.86 MB","file_type":"img","updated_at":1513219273},"3":{"eng":"t1.jpg","trad":"t1.jpg","simp":"t1.jpg","path":"gallery\/H3dTJXibcf5AqVtG34bTgAeTm0oqqCqjjlX9zBU0.jpeg","file_name":"t1.jpg","file_size":"712.96 KB","file_type":"img","updated_at":1513219330},"4":{"eng":"t2.jpg","trad":"t2.jpg","simp":"t2.jpg","path":"gallery\/KLdszncoINKHINxPD0DNhC6Hk30kWO9VUzLM3E30.jpeg","file_name":"t2.jpg","file_size":"1.86 MB","file_type":"img","updated_at":1513219374},"5":{"eng":"t1.jpg","trad":"t1.jpg","simp":"t1.jpg","path":"gallery\/TjrWYtPYd2E3fXGMFd6WU3qQ2BmKH3tn6POWPrqe.jpeg","file_name":"t1.jpg","file_size":"712.96 KB","file_type":"img","updated_at":1513219392},"6":{"eng":"St Barths Promotion Booklet","trad":"\u96f2\u6d77\u5ba3\u50b3\u518a\u5b50","simp":"\u4e91\u6d77\u5ba3\u4f20\u518c\u5b50","path":"gallery\/0LNNoOXOcSfGifruorl3fNHHDftOtYieKv02rTmH.pdf","file_name":"sb_moodbook_web_180104.pdf","file_size":"34.22 MB","file_type":"pdf","updated_at":1515149042},"8":{"eng":"light201803031606.jpg","trad":"light201803031606.jpg","simp":"light201803031606.jpg","path":"gallery\/3PwnsV1rQ4bBNM00nMPkkkpBVKjmYWMXDbC5Q0pi.jpeg","file_name":"light201803031606.jpg","file_size":"15.47 KB","file_type":"img","updated_at":1520064510},"9":{"eng":"light201803031607.jpg","trad":"light201803031607.jpg","simp":"light201803031607.jpg","path":"gallery\/YfeWsCrmXdc4dua8E5gSpYUmQsT7MyiqT0m6ZDxM.jpeg","file_name":"light201803031607.jpg","file_size":"15.47 KB","file_type":"img","updated_at":1520064531},"10":{"eng":"light201803031608.jpg","trad":"light201803031608.jpg","simp":"light201803031608.jpg","path":"gallery\/Toa5eX89qhtOSkoKwYu632k4eOeLtnMGHfSmxuxV.jpeg","file_name":"light201803031608.jpg","file_size":"15.47 KB","file_type":"img","updated_at":1520064576},"11":{"eng":"scene.jpg","trad":"scene.jpg","simp":"scene.jpg","path":"gallery\/RQjHO0GoarzFRfQuqsu0qPOr4h8bUVsNRsYYgsRd.jpeg","file_name":"scene.jpg","file_size":"487.08 KB","file_type":"img","updated_at":1520064616}},"announcement":{"1":{"eng":"testing","trad":"\u6e2c\u8a66","simp":"\u6d4b\u8bd5","path":"announcement\/qLrPvYhdJbxFEEblmeq2vyHAS8dvQcKiNs8g9iey.pdf","file_name":"The-Data-Engineers-Guide-to-Apache-Spark.pdf","file_size":"12.61 MB","updated_at":1554894793,"date_of_printing":"10-04-2019","order":1}},
    //     "tender_document":{"1":{"eng":"02-06-2019 Tender Document No.1","trad":"02-06-2019 \u6295\u6a19\u6587\u4ef6\u7b2c1\u865f","simp":"02-06-2019 \u6295\u6807\u6587\u4ef6\u7b2c1\u53f7","path":"tender_document\/testTenderDoc.pdf","file_name":"testTenderDoc.pdf","file_size":"16.36 KB","updated_at":1559462724,"issue_date":"02-06-2019","serial_number":"1","order":1},"2":{"eng":"02-06-2019 Tender Document No.1","trad":"02-06-2019 \u6295\u6a19\u6587\u4ef6\u7b2c1\u865f","simp":"02-06-2019 \u6295\u6807\u6587\u4ef6\u7b2c1\u53f7","path":"tender_document\/test2.pdf","file_name":"test2.pdf","file_size":null,"updated_at":1559463006,"issue_date":"02-06-2019","serial_number":"1","order":2},"3":{"eng":"02-06-2019 Tender Document No.3","trad":"02-06-2019 \u6295\u6a19\u6587\u4ef6\u7b2c3\u865f","simp":"02-06-2019 \u6295\u6807\u6587\u4ef6\u7b2c3\u53f7","path":"tender_document\/IMG_9356.JPG","file_name":"IMG_9356.JPG","file_size":"1.57 MB","updated_at":1559463494,"issue_date":"02-06-2019","serial_number":"3","order":3}},"last_update_date":{"1":{"updated_at":1559463494}}
    //   }

    //   for (let key in d) {
    //     transData[key] = t.transformData(key, d[key])
    //   }

    //   transData.aerial_photograph = transData.aerial_photograph ? transData.aerial_photograph : []
    //   transData.announcement = transData.announcement ? transData.announcement : []
    //   transData.deed_of_mutual_covenant = transData.deed_of_mutual_covenant ? transData.deed_of_mutual_covenant : []
    //   transData.gallery = transData.gallery ? transData.gallery : []
    //   transData.price_list = transData.price_list ? transData.price_list : []
    //   transData.register_of_transactions = transData.register_of_transactions ? transData.register_of_transactions : []
    //   transData.sales_arrangements = transData.sales_arrangements ? transData.sales_arrangements : []
    //   transData.sales_brochure = transData.sales_brochure ? transData.sales_brochure : []

    //   t.setState({
    //     data: transData
    //   });
    // }, respTime * 1000)

    // const pingInterval = 5
    // const execGetList = function() {
    //   console.log('execGetList...');
    //   console.log(transData)
    //   if (Object.keys(transData).length === 0 && transData.constructor === Object) {
    //     setTimeout(execGetList, pingInterval * 1000);
    //   }
    // }
    // t.t0 = setTimeout(execGetList, pingInterval * 1000);
    // !!!!!!!!!! dev
  }

  changePositioning() {
    // const ratio = 0.75;
    const ratio = 0.7;

    if ($(window).height() / ratio < 1100) {
      $('.App').css({
        'min-width': '1100px'
      })
    } else {
      $('.App').css({
        'min-width': $(window).height() / ratio + 'px'
      })
    }
    
  }

  updateLang() {

    let isMobile = platform.os.family === 'iOS' || platform.os.family === 'Android';

    if (!isMobile) {
      this.lang = this.props.location.pathname.split('/')[2];
      if (!this.lang || (this.lang !== 'en' && this.lang !== 'tc' && this.lang !== 'sc')) {
        this.lang = 'en'
      }
    } else {
      this.lang = this.props.location.pathname.split('/')[3];
      if (!this.lang || (this.lang !== 'en' && this.lang !== 'tc' && this.lang !== 'sc')) {
        this.lang = 'en'
      }
    }
    console.log(this.lang)
    this.setState({
      lang: this.lang
    });
  }

  updateRouteByDevice(url){
    this.props.router.replace(url);
  }

  bgImageOnload(){
    $('#loader').fadeOut(1000)
  }
  bgImageInit(){
    $('#loader').fadeIn()
  }

  render() {
    console.log('App.js ' + platform.os.family)
    let isMobile = platform.os.family === 'iOS' || platform.os.family === 'Android';
    let urlIsMobile = this.props.location.pathname.split('/')[2] === 'm';

    // console.log(isMobile)
    // console.log(urlIsMobile)

    // normal
    if (!isMobile && urlIsMobile) {
      return <DeviceController
          updateRouteByDevice={this.updateRouteByDevice}
          location={this.props.location.pathname}
        />
    } else
    if (isMobile && !urlIsMobile) {
      return <DeviceController
          updateRouteByDevice={this.updateRouteByDevice}
          location={this.props.location.pathname}
        />
    } else
    if (!isMobile) {
      return <div className='App'>
        <DeviceController
          updateRouteByDevice={this.updateRouteByDevice}
          location={this.props.location.pathname}
        />
        <div>
          <Header lang={this.state.lang} pathName={this.props.location.pathname}/>
          <ReactCSSTransitionGroup
            className={transitionClassName}
            transitionName={pageTransitionName}
            transitionEnterTimeout={transitionEnterTimeout}
            transitionLeaveTimeout={transitionDuration}>
            {React.cloneElement(
              this.props.children,
              {
                key: this.props.location.pathname,
                lang: this.state.lang,
                updateLang: this.updateLang,
                data: this.state.data,
                bgImageOnload: this.bgImageOnload
              }
            )}
          </ReactCSSTransitionGroup>
          <Footer lang={this.state.lang} pathName={this.props.location.pathname}/>
          <div id='loader'></div>
        </div>
      </div>
    } else {
      return <div className='MobileApp'>
        <DeviceController
          updateRouteByDevice={this.updateRouteByDevice}
          location={this.props.location.pathname}
        />
        <div>
          <MMenu lang={this.state.lang} pathName={this.props.location.pathname}/>
          <ReactCSSTransitionGroup
            className={transitionClassName}
            transitionName={pageTransitionName}
            transitionEnterTimeout={transitionEnterTimeout}
            transitionLeaveTimeout={transitionDuration}>
            {React.cloneElement(
              this.props.children,
              {
                key: this.props.location.pathname,
                lang: this.state.lang,
                updateLang: this.updateLang,
                data: this.state.data,
                bgImageOnload: this.bgImageOnload
              }
            )}
          </ReactCSSTransitionGroup>
          <MFooter lang={this.state.lang} pathName={this.props.location.pathname}/>
          <div id='loader'></div>
        </div>
      </div>
    }

  }
};

class App extends Component {
  render() {
    return (
      <Router history={browserHistory}>
        <Route path='/p2' component={Page}>
          {/* <IndexRoute component={Landing}/> */}
          <IndexRoute component={Home}/>
          <Route path={routeConfig.home.en.url} component={Home}/>
          <Route path={routeConfig.home.tc.url} component={Home}/>
          <Route path={routeConfig.home.sc.url} component={Home}/>
          <Route path={routeConfig.gallery.en.url} component={Gallery}/>
          <Route path={routeConfig.gallery.tc.url} component={Gallery}/>
          <Route path={routeConfig.gallery.sc.url} component={Gallery}/>
          <Route path={routeConfig.announcement.en.url} component={Announcement}/>
          <Route path={routeConfig.announcement.tc.url} component={Announcement}/>
          <Route path={routeConfig.announcement.sc.url} component={Announcement}/>
          <Route path={routeConfig.salesBrochure.en.url} component={SalesBrochure}/>
          <Route path={routeConfig.salesBrochure.tc.url} component={SalesBrochure}/>
          <Route path={routeConfig.salesBrochure.sc.url} component={SalesBrochure}/>
          <Route path={routeConfig.priceList.en.url} component={PriceList}/>
          <Route path={routeConfig.priceList.tc.url} component={PriceList}/>
          <Route path={routeConfig.priceList.sc.url} component={PriceList}/>
          <Route path={routeConfig.salesArrangements.en.url} component={SalesArrangements}/>
          <Route path={routeConfig.salesArrangements.tc.url} component={SalesArrangements}/>
          <Route path={routeConfig.salesArrangements.sc.url} component={SalesArrangements}/>
          <Route path={routeConfig.registerOfTransactions.en.url} component={RegisterOfTransactions}/>
          <Route path={routeConfig.registerOfTransactions.tc.url} component={RegisterOfTransactions}/>
          <Route path={routeConfig.registerOfTransactions.sc.url} component={RegisterOfTransactions}/>
          <Route path={routeConfig.deedOfMutualCovenant.en.url} component={DeedOfMutualCovenant}/>
          <Route path={routeConfig.deedOfMutualCovenant.tc.url} component={DeedOfMutualCovenant}/>
          <Route path={routeConfig.deedOfMutualCovenant.sc.url} component={DeedOfMutualCovenant}/>
          <Route path={routeConfig.aerialPhotograph.en.url} component={AerialPhotograph}/>
          <Route path={routeConfig.aerialPhotograph.tc.url} component={AerialPhotograph}/>
          <Route path={routeConfig.aerialPhotograph.sc.url} component={AerialPhotograph}/>
          <Route path={routeConfig.tenderDocuments.en.url} component={TenderDocuments}/>
          <Route path={routeConfig.tenderDocuments.tc.url} component={TenderDocuments}/>
          <Route path={routeConfig.tenderDocuments.sc.url} component={TenderDocuments}/>

          <Route path='/p2/m' component={MHome}/>
          <Route path={routeConfig.home.en.mobileUrl} component={MHome}/>
          <Route path={routeConfig.home.tc.mobileUrl} component={MHome}/>
          <Route path={routeConfig.home.sc.mobileUrl} component={MHome}/>
          <Route path={routeConfig.gallery.en.mobileUrl} component={MGallery}/>
          <Route path={routeConfig.gallery.tc.mobileUrl} component={MGallery}/>
          <Route path={routeConfig.gallery.sc.mobileUrl} component={MGallery}/>
          <Route path={routeConfig.announcement.en.mobileUrl} component={MAnnouncement}/>
          <Route path={routeConfig.announcement.tc.mobileUrl} component={MAnnouncement}/>
          <Route path={routeConfig.announcement.sc.mobileUrl} component={MAnnouncement}/>
          <Route path={routeConfig.salesBrochure.en.mobileUrl} component={MSalesBrochure}/>
          <Route path={routeConfig.salesBrochure.tc.mobileUrl} component={MSalesBrochure}/>
          <Route path={routeConfig.salesBrochure.sc.mobileUrl} component={MSalesBrochure}/>
          <Route path={routeConfig.priceList.en.mobileUrl} component={MPriceList}/>
          <Route path={routeConfig.priceList.tc.mobileUrl} component={MPriceList}/>
          <Route path={routeConfig.priceList.sc.mobileUrl} component={MPriceList}/>
          <Route path={routeConfig.salesArrangements.en.mobileUrl} component={MSalesArrangements}/>
          <Route path={routeConfig.salesArrangements.tc.mobileUrl} component={MSalesArrangements}/>
          <Route path={routeConfig.salesArrangements.sc.mobileUrl} component={MSalesArrangements}/>
          <Route path={routeConfig.registerOfTransactions.en.mobileUrl} component={MRegisterOfTransactions}/>
          <Route path={routeConfig.registerOfTransactions.tc.mobileUrl} component={MRegisterOfTransactions}/>
          <Route path={routeConfig.registerOfTransactions.sc.mobileUrl} component={MRegisterOfTransactions}/>
          <Route path={routeConfig.deedOfMutualCovenant.en.mobileUrl} component={MDeedOfMutualCovenant}/>
          <Route path={routeConfig.deedOfMutualCovenant.tc.mobileUrl} component={MDeedOfMutualCovenant}/>
          <Route path={routeConfig.deedOfMutualCovenant.sc.mobileUrl} component={MDeedOfMutualCovenant}/>
          <Route path={routeConfig.aerialPhotograph.en.mobileUrl} component={MAerialPhotograph}/>
          <Route path={routeConfig.aerialPhotograph.tc.mobileUrl} component={MAerialPhotograph}/>
          <Route path={routeConfig.aerialPhotograph.sc.mobileUrl} component={MAerialPhotograph}/>
          <Route path={routeConfig.tenderDocuments.en.mobileUrl} component={MTenderDocuments}/>
          <Route path={routeConfig.tenderDocuments.tc.mobileUrl} component={MTenderDocuments}/>
          <Route path={routeConfig.tenderDocuments.sc.mobileUrl} component={MTenderDocuments}/>

          {/* <Route path={routeConfig.application.en.mobileUrl} component={MApplication}/>
          <Route path={routeConfig.application.tc.mobileUrl} component={MApplication}/>
          <Route path={routeConfig.application.sc.mobileUrl} component={MApplication}/> */}

          <Redirect from='*' to='/' />
        </Route>
      </Router>
    );
  }
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js